import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/privacy'

export const getStaticProps = Page.getStaticProps

export default withAuthUser<Page.PrivacyPageProps>()(Page.Privacy)
